import React from "react";
import { Box, ListItem, Typography } from "@mui/material";
import "./MobileApplist.css";
import LazyImage from "../../utils/LazyImage";
import { Link } from "pepsico-ds";
export default function MobileApplist({ title, link, id, url }) {
  const handleNavigate = (url) => {
    window.open(url, "_blank");
  };
  return (
    <ListItem className="list-v2-item no-background">
      <Box className="list-item-image">
        <LazyImage width={40} height={40} blocksize={true} url={url} />
      </Box>
      <Box className="content">
        <Box className="content-group">
          <Box className="content-group-title">
            <Typography
              sx={{
                fontFamily: "Inter",
                fontSize: "1rem",
                fontWeight: 500,
                lineHeight: "140%",
                maxWidth: "80%",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {title}
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box>
        <Link
          className=""
          label=""
          onClick={() => handleNavigate(link)}
          showIconTrailing
          size="small"
          style={{
            paddingLeft: "0.75rem",
            paddingRight: "0.75rem",
          }}
          useAnchor
        />
      </Box>
    </ListItem>
  );
}
